import { AvatarColor } from '@doveit/bricks';
import { RankType } from '../../providers/api/dtos';
import { RANKING_RULES } from '../constants';

export function getConfigByRank(
  rank: number,
  rankingType: RankType,
): { color: AvatarColor; shownPosition: number; label: string } {
  const rules = RANKING_RULES[rankingType];
  const rule = rules.find((r) => rank <= r.maxRank);

  if (!rule) {
    return { color: 'neutral', shownPosition: rank, label: 'Posizione' };
  }

  const shownPosition = typeof rule.shownPosition === 'function'
    ? rule.shownPosition(rank)
    : rule.shownPosition;

  return {
    color: rule.color,
    shownPosition,
    label: rule.label,
  };
}
